import{defineMessages}from'react-intl';

export default defineMessages({
button_submit:{
id:'i18n.create_stock_lift_panel.button_submit',
defaultMessage:'Submit'},

button_cancel:{
id:'i18n.create_stock_lift_panel.button_cancel',
defaultMessage:'Cancel'}});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNyYy9wYWdlcy9DcmVhdGVTdG9ja0xpZnRQYWdlL0NyZWF0ZVN0b2NrTGlmdFBhbmVsL0NyZWF0ZVN0b2NrTGlmdFBhbmVsLm1lc3NhZ2VzLmpzIl0sIm5hbWVzIjpbImRlZmluZU1lc3NhZ2VzIiwiYnV0dG9uX3N1Ym1pdCIsImlkIiwiZGVmYXVsdE1lc3NhZ2UiLCJidXR0b25fY2FuY2VsIl0sIm1hcHBpbmdzIjoiQUFBQSxPQUFTQSxjQUFULEtBQStCLFlBQS9COztBQUVBLGNBQWVBLGdCQUFlO0FBQzVCQyxjQUFlO0FBQ2JDLEdBQUksNENBRFM7QUFFYkMsZUFBZ0IsUUFGSCxDQURhOztBQUs1QkMsY0FBZTtBQUNiRixHQUFJLDRDQURTO0FBRWJDLGVBQWdCLFFBRkgsQ0FMYSxDQUFmLENBQWYiLCJmaWxlIjoiQ3JlYXRlU3RvY2tMaWZ0UGFuZWwubWVzc2FnZXMuanMiLCJzb3VyY2VSb290IjoiL2FwcCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IGRlZmluZU1lc3NhZ2VzIH0gZnJvbSAncmVhY3QtaW50bCc7XG5cbmV4cG9ydCBkZWZhdWx0IGRlZmluZU1lc3NhZ2VzKHtcbiAgYnV0dG9uX3N1Ym1pdDoge1xuICAgIGlkOiAnaTE4bi5jcmVhdGVfc3RvY2tfbGlmdF9wYW5lbC5idXR0b25fc3VibWl0JyxcbiAgICBkZWZhdWx0TWVzc2FnZTogJ1N1Ym1pdCcsXG4gIH0sXG4gIGJ1dHRvbl9jYW5jZWw6IHtcbiAgICBpZDogJ2kxOG4uY3JlYXRlX3N0b2NrX2xpZnRfcGFuZWwuYnV0dG9uX2NhbmNlbCcsXG4gICAgZGVmYXVsdE1lc3NhZ2U6ICdDYW5jZWwnLFxuICB9LFxufSk7XG4iXX0=


//////////////////
// WEBPACK FOOTER
// ./src/pages/CreateStockLiftPage/CreateStockLiftPanel/CreateStockLiftPanel.messages.js
// module id = 2311
// module chunks = 0